import { ApiResponse, ApiResponseContent } from '../models/custom-models';
import ApiBase from './base/ApiBase';

export enum MergeErrors {
    GetLinkToken = "Could not retrieve Merge link token",
    GetIntegrationStatus = "Could not fetch integration status",
    DisconnectIntegration = "Could not disconnect integration",
    SyncIntegration = "Could not sync integration data"
}

export enum IntegrationSyncStatusStatusEnum {
    NotConfigured = "NotConfigured",
    Syncing = "Syncing",
    Done = "Done",
    Failed = "Failed",
    NeverSynced = "NeverSynced"
}

export interface IntegrationSyncStatus {
    Status: IntegrationSyncStatusStatusEnum;
    LastSyncCompleted?: Date;
    IntegrationName?: string;
}

class MergeClient extends ApiBase {
    private controllerName: string = 'Organization';

    public async GetLinkToken(category: string = "hris"): Promise<ApiResponseContent<string>> {
        const linkToken = await this.GetAsync(`${this.controllerName}/mergelinktoken`); // ?category=${category}`);
        return linkToken;
    }

    public async GetIntegrationSyncStatus(): Promise<ApiResponseContent<IntegrationSyncStatus>> {
        const status = await this.GetAsync(`${this.controllerName}/syncstatus`);
        return status;
    }

    public async SwapPublicToken(publicToken: string): Promise<ApiResponse> {
        return this.PostAsync(`${this.controllerName}/mergeaccounttoken?token=${publicToken}`);
    }
    
    public async SyncIntegration(): Promise<ApiResponse> {
        return this.PostAsync(`${this.controllerName}/syncintegration`);
    }
}

export default MergeClient;
